module.exports = __webpack_public_path__ + "static/media/032.5409091d.jpg";